import { createSlice } from '@reduxjs/toolkit';
import { strapiApi } from '../../api/strapiApi';

// Estado inicial
const initialState = {
  content: {},
  loading: false,
  error: null,
  feeFlag: null, // Para almacenar específicamente el fee flag
};

// Slice
const strapiSlice = createSlice({
  name: 'strapi',
  initialState,
  reducers: {
    // Reducer para limpiar errores
    clearStrapiError: (state) => {
      state.error = null;
    },
    // Reducer para resetear el estado
    resetStrapi: (state) => {
      state.content = {};
      state.error = null;
      state.feeFlag = null;
    },
    // Reducer para setear el feeFlag directamente (útil para MX)
    setFeeFlag: (state, action) => {
      state.feeFlag = action.payload;
      if (action.payload === false) {
        state.content = { sections: [] };
      }
    },
  },
  extraReducers: (builder) => {
    builder
      // Caso pendiente
      .addMatcher(
        strapiApi.endpoints.getStrapiContent.matchPending,
        (state) => {
          state.loading = true;
          state.error = null;
        }
      )
      // Caso exitoso
      .addMatcher(
        strapiApi.endpoints.getStrapiContent.matchFulfilled,
        (state, action) => {
          state.loading = false;
          state.content = action.payload;

          // Extraer el fee_flag si está disponible (para brokers_legalizador)
          const { sections } = action.payload;
          if (sections && sections.length > 0 && sections[0].extra_data) {
            state.feeFlag = sections[0].extra_data.fee_flag;
          } else {
            state.feeFlag = false;
          }
        }
      )
      // Caso de error
      .addMatcher(
        strapiApi.endpoints.getStrapiContent.matchRejected,
        (state, action) => {
          state.loading = false;
          state.error = action.error?.message || 'Error al obtener contenido de Strapi';
          state.feeFlag = false; // Por defecto false si hay error
        }
      );
  },
});

// Exporta las acciones
export const { clearStrapiError, resetStrapi, setFeeFlag } = strapiSlice.actions;

// Exporta el reducer
export default strapiSlice.reducer;

// Selectores
export const selectStrapiContent = (state) => state.strapi.content;
export const selectStrapiLoading = (state) => state.strapi.loading;
export const selectStrapiError = (state) => state.strapi.error;
export const selectFeeFlag = (state) => state.strapi.feeFlag;
